/* ============================================================
   Bedenimi Bul (Find My Size) — Fahhar / Stiletto teması
   Kendi kendine yeten beden önerici. Tema JS'ine bağımlı değildir;
   tetikleyici [data-fms-open], veri [data-fms-config] üzerinden gelir.
   ============================================================ */
(function () {
  "use strict";

  var overlay = null;      // lazily built
  var config = null;       // parsed from [data-fms-config]
  var state = {};
  var touched = {};
  var stepIndex = 0;
  var completed = false;
  var started = false;

  var STEPS = [
    { key: "height", label: "Boy", unit: "cm", min: 140, max: 200, def: 165, hint: "Ayakkabısız, duvara yaslanarak." },
    { key: "weight", label: "Kilo", unit: "kg", min: 40, max: 130, def: 60, hint: "Yaklaşık değer yeterli." },
    { key: "bust", label: "Göğüs", unit: "cm", min: 70, max: 120, def: 90, hint: "Bilmiyorsan tahminimizle devam et; mezuran varsa göğsün en dolgun yerinden ölç." },
    { key: "waist", label: "Bel", unit: "cm", min: 55, max: 100, def: 72, hint: "Bilmiyorsan tahminimizle devam et; ölçersen belin en ince noktası." },
    { key: "hip", label: "Basen", unit: "cm", min: 80, max: 130, def: 98, hint: "Bilmiyorsan tahminimizle devam et; ölçersen kalçanın en geniş noktası." }
  ];

  /* Config'ten (Liquid/JSON) gelen her metin HTML'e gömülmeden önce kaçışlanır */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------------- beden hesaplama ---------------- */
  function sizeTable() { return config.sizeChart; }
  function order() { return sizeTable().map(function (r) { return r.code; }); }

  function sizeForMeasurement(value, key) {
    var t = sizeTable();
    var first = t[0], last = t[t.length - 1];
    if (value < first[key][0]) return { row: first, clamped: "under" };
    for (var i = 0; i < t.length; i++) {
      if (value <= t[i][key][1]) return { row: t[i], clamped: null };
    }
    return { row: last, clamped: "over" };
  }

  function recommend(bust, waist, hip) {
    var picks = {
      bust: sizeForMeasurement(bust, "bust"),
      waist: sizeForMeasurement(waist, "waist"),
      hip: sizeForMeasurement(hip, "hip")
    };
    var counts = {};
    [picks.bust, picks.waist, picks.hip].forEach(function (p) {
      counts[p.row.code] = (counts[p.row.code] || 0) + 1;
    });
    var winner = null, max = 0;
    Object.keys(counts).forEach(function (code) {
      if (counts[code] > max) { max = counts[code]; winner = code; }
    });
    if (max < 2) {
      var all = [picks.bust.row.code, picks.waist.row.code, picks.hip.row.code];
      var ord = order();
      all.sort(function (a, b) { return ord.indexOf(b) - ord.indexOf(a); });
      winner = all[0];
    }
    var clamped = [picks.bust, picks.waist, picks.hip].some(function (p) { return p.clamped; });
    var confidence = clamped ? "out" : max >= 3 ? "high" : max === 2 ? "medium" : "low";
    var winnerRow = sizeTable().filter(function (r) { return r.code === winner; })[0];
    return { winnerRow: winnerRow, picks: picks, confidence: confidence };
  }

  function estimateMeasurements(heightCm, weightKg) {
    var bmi = weightKg / Math.pow(heightCm / 100, 2);
    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, Math.round(v))); }
    return {
      bust: clamp(58 + bmi * 1.55, 70, 120),
      waist: clamp(38 + bmi * 1.5, 55, 100),
      hip: clamp(62 + bmi * 1.65, 80, 130)
    };
  }

  /* ---------------- overlay iskeleti ---------------- */
  function buildOverlay() {
    overlay = document.createElement("div");
    overlay.className = "fms-overlay";
    overlay.innerHTML =
      '<div class="fms-sheet" role="dialog" aria-modal="true" aria-label="Bedenimi Bul">' +
      '  <div class="fms-header">' +
      '    <span class="fms-eyebrow" data-fms-eyebrow>BEDENİMİ BUL</span>' +
      '    <button type="button" class="fms-close" data-fms-close aria-label="Kapat">&times;</button>' +
      "  </div>" +
      '  <div class="fms-progress" data-fms-progress></div>' +
      '  <div class="fms-controls" data-fms-controls></div>' +
      "</div>";
    document.body.appendChild(overlay);

    var progress = overlay.querySelector("[data-fms-progress]");
    STEPS.forEach(function () {
      progress.insertAdjacentHTML("beforeend", '<div class="fms-progress__dot"><i></i></div>');
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeQuiz();
    });
    overlay.querySelector("[data-fms-close]").addEventListener("click", closeQuiz);
  }

  /* ---------------- akış ---------------- */
  function resetState() {
    state = {}; touched = {};
    STEPS.forEach(function (s) { state[s.key] = s.def; });
    stepIndex = 0;
    completed = false;
  }

  function renderProgress() {
    var dots = overlay.querySelectorAll(".fms-progress__dot i");
    dots.forEach(function (dot, i) {
      dot.style.width = i < stepIndex ? "100%" : i === stepIndex ? "50%" : "0%";
    });
  }

  function sliderFill(slider) {
    var pct = (slider.value - slider.min) / (slider.max - slider.min) * 100;
    slider.style.background = "linear-gradient(to right, #211d18 " + pct + "%, #e3ddd2 " + pct + "%)";
  }

  function clearResult() {
    var w = overlay.querySelector(".fms-result");
    if (w) w.remove();
  }

  function renderStep() {
    clearResult();
    overlay.querySelector("[data-fms-progress]").style.display = "";
    overlay.querySelector("[data-fms-eyebrow]").textContent =
      "BEDENİMİ BUL · ADIM " + (stepIndex + 1) + "/" + STEPS.length;
    renderProgress();
    var s = STEPS[stepIndex];
    if ((s.key === "bust" || s.key === "waist" || s.key === "hip") && !touched[s.key]) {
      state[s.key] = estimateMeasurements(state.height, state.weight)[s.key];
    }

    var controls = overlay.querySelector("[data-fms-controls]");
    controls.innerHTML =
      '<div class="fms-ctl-row">' +
      '  <div><div class="fms-ctl-title">' + s.label + '</div><div class="fms-ctl-hint">' + s.hint + "</div></div>" +
      '  <div class="fms-ctl-pill" data-fms-readout>' + state[s.key] + "<small>" + s.unit + "</small></div>" +
      "</div>" +
      '<div class="fms-slider-row">' +
      '  <button type="button" class="fms-stepper" data-fms-dec aria-label="Azalt">−</button>' +
      '  <div class="fms-slider-col">' +
      '    <input type="range" class="fms-range" data-fms-slider min="' + s.min + '" max="' + s.max + '" step="1" value="' + state[s.key] + '">' +
      '    <div class="fms-slider-scale"><span>' + s.min + "</span><span>" + s.max + "</span></div>" +
      "  </div>" +
      '  <button type="button" class="fms-stepper" data-fms-inc aria-label="Artır">+</button>' +
      "</div>" +
      '<div class="fms-buttons">' +
      '<button type="button" class="fms-btn-back' + (stepIndex === 0 ? " is-hidden" : "") + '" data-fms-back>‹ Geri</button>' +
      '<button type="button" class="fms-btn-next" data-fms-next>' + (stepIndex === STEPS.length - 1 ? "Sonucu Gör" : "İleri") + "</button>" +
      "</div>" +
      (stepIndex === 0 ? '<div class="fms-privacy">Ölçülerin cihazında kalır; kaydedilmez, paylaşılmaz.</div>' : "");

    var slider = controls.querySelector("[data-fms-slider]");
    var readout = controls.querySelector("[data-fms-readout]");
    sliderFill(slider);

    function setValue(v) {
      v = Math.max(s.min, Math.min(s.max, v));
      state[s.key] = v;
      touched[s.key] = true;
      slider.value = v;
      readout.innerHTML = v + "<small>" + s.unit + "</small>";
      sliderFill(slider);
    }
    slider.addEventListener("input", function () { setValue(Number(slider.value)); });
    controls.querySelector("[data-fms-dec]").addEventListener("click", function () { setValue(state[s.key] - 1); });
    controls.querySelector("[data-fms-inc]").addEventListener("click", function () { setValue(state[s.key] + 1); });
    controls.querySelector("[data-fms-back]").addEventListener("click", function () {
      if (stepIndex > 0) { stepIndex--; renderStep(); }
    });
    controls.querySelector("[data-fms-next]").addEventListener("click", function () {
      if (stepIndex < STEPS.length - 1) { stepIndex++; renderStep(); }
      else { renderResult(); }
    });
  }

  function confidenceCopy(level, code) {
    if (level === "high") return { cls: "good", label: "TAM İSABET", copy: "Göğüs, bel ve basen ölçülerinin üçü de aynı bedeni gösteriyor." };
    if (level === "medium") return { cls: "good", label: "İYİ EŞLEŞME", copy: "Üç ölçüden ikisi bu bedeni gösteriyor." };
    if (level === "out") return { cls: "warn", label: "TABLO SINIRINDA", copy: "Ölçülerin standart tablomuzun sınırında; bu beden sana en yakın olanı. Emin olamazsan bize yazabilirsin, birlikte bakalım." };
    return { cls: "warn", label: "İKİ BEDEN ARASI", copy: "Vücut ölçülerin bedenler arasında kalıyor; rahat kalıp için " + code + " öneriyoruz." };
  }

  function breakdownCol(key, value, code) {
    return '<div class="fms-breakdown__col"><span class="fms-breakdown__key">' + key + '</span><span class="fms-breakdown__size">' + code + '</span><span class="fms-breakdown__cm">' + value + " cm</span></div>";
  }

  /* Öneriyi üründeki gerçek beden seçeneğiyle eşle.
     Dikkat: mağaza numaraları (örn. "1 (36-38)", "2 (40-42)") tablo
     numaralarıyla AYNI DEĞİL — bu yüzden numara eşleştirmesi yapılmaz;
     önce birebir metin, sonra konfeksiyon numarası aralık örtüşmesi kullanılır. */
  function parseSizeRange(str) {
    var m = String(str).match(/(\d{2,3})\s*[-–\/]\s*(\d{2,3})/);
    if (m) return [Number(m[1]), Number(m[2])];
    /* tekli beden: "38" gibi tek konfeksiyon numarası da aralık sayılır */
    m = String(str).match(/(\d{2,3})/);
    if (m) {
      var n = Number(m[1]);
      if (n >= 30 && n <= 60) return [n, n];
    }
    return null;
  }

  function matchVariantValue(row) {
    var values = (config && config.sizeValues) || [];
    var i, v;
    /* üründe tek beden seçeneği varsa ("Standart", "STD" vb.) sonuç odur */
    if (values.length === 1) return String(values[0]);
    /* 1) tablo aralığı ("36-38") değerin içinde birebir geçiyorsa */
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      if (v.indexOf(row.label) !== -1) return v;
    }
    /* 2) harf kodu birebir eşleşiyorsa ("S", "2XL") */
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      if (v.replace(/\s/g, "").toUpperCase() === row.code.toUpperCase()) return v;
    }
    /* 3) konfeksiyon numarası aralığı örtüşmesi: en çok örtüşen, eşitlikte büyük olan */
    var rowRange = parseSizeRange(row.label);
    if (!rowRange) return null;
    var rowMid = (rowRange[0] + rowRange[1]) / 2;
    var best = null, bestOverlap = -1, bestDist = Infinity, bestMid = -1;
    for (i = 0; i < values.length; i++) {
      v = String(values[i]);
      var r = parseSizeRange(v);
      if (!r) continue;
      var overlap = Math.min(r[1], rowRange[1]) - Math.max(r[0], rowRange[0]);
      var mid = (r[0] + r[1]) / 2;
      var dist = Math.abs(mid - rowMid);
      var better =
        overlap > bestOverlap ||
        (overlap === bestOverlap && dist < bestDist) ||
        (overlap === bestOverlap && dist === bestDist && mid > bestMid);
      if (better) { best = v; bestOverlap = overlap; bestDist = dist; bestMid = mid; }
    }
    /* hiç örtüşme yok ve en yakın seçenek 3 numaradan uzaksa eşleştirme yapma —
       yanlış bedene yönlendirmektense öneriyi sadece bilgi olarak gösteririz */
    if (best === null || (bestOverlap <= 0 && bestDist > 3)) return null;
    return best;
  }

  function applyVariantSelection(row) {
    var value = matchVariantValue(row);
    if (!value || !config.sizeOptionPosition) return false;
    /* 1) Chip/swatch tipi seçici (fahhar'da Beden chip olarak ayarlı):
       temanın kendi tıklama mantığı ve görsel seçim çalışsın diye
       doğrudan ilgili butona gerçek click gönderilir. */
    var valSel = window.CSS && CSS.escape ? CSS.escape(value) : String(value).replace(/(["\\])/g, "\\$1");
    var chip = document.querySelector(
      '[data-product-option="option' + config.sizeOptionPosition + '"] button[data-option-value="' + valSel + '"]'
    );
    if (chip) {
      chip.click();
      return true;
    }
    /* 2) Açılır liste tipi seçici */
    var optName = window.CSS && CSS.escape ? CSS.escape(config.sizeOptionName) : String(config.sizeOptionName).replace(/["\\]/g, "");
    var select = document.querySelector('select[name="options[' + optName + ']"]');
    if (!select) return false;
    var found = false;
    Array.prototype.forEach.call(select.options, function (opt) {
      if (opt.value === value) found = true;
    });
    if (!found) return false;
    select.value = value;
    select.dispatchEvent(new Event("change", { bubbles: true }));
    return true;
  }

  function renderResult() {
    completed = true;
    overlay.querySelector("[data-fms-eyebrow]").textContent = "BEDENİMİ BUL · SONUÇ";
    overlay.querySelector("[data-fms-progress]").style.display = "none";

    var r = recommend(state.bust, state.waist, state.hip);
    var conf = confidenceCopy(r.confidence, r.winnerRow.code);
    var variantValue = matchVariantValue(r.winnerRow);

    /* Ürün beden/stok kontrolü: öneri bu üründe yoksa veya stok dışıysa müşteriye söyle */
    var availability = (config && config.sizeAvailability) || {};
    var hasSizes = config && config.sizeValues && config.sizeValues.length > 0;
    var availNote = "";
    if (hasSizes && !variantValue) {
      availNote = "Bu üründe " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ") bedenine denk gelen bir seçenek maalesef yok.";
    } else if (variantValue && Object.prototype.hasOwnProperty.call(availability, variantValue) && availability[variantValue] === false) {
      availNote = esc(variantValue) + " bedeni bu üründe şu an tükendi. Bedeni yine de seçebilirsin; stok gelince haber ver seçeneği çıkarsa kullanabilirsin.";
    }

    clearResult();
    /* Büyük başlık: ürünün GERÇEK beden etiketi (mağazada harf bedeni yok —
       "M" göstermek yanıltır). Tablo harfi/aralığı küçük alt satıra iner.
       Eşleşme yoksa eskisi gibi tablo bedeni gösterilir. */
    var headline, subline;
    if (variantValue) {
      headline = esc(variantValue);
      if (hasSizes && config.sizeValues.length === 1) {
        subline = "TEK BEDEN ÜRÜN · ÖLÇÜLERİN: " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ")";
      } else {
        subline = "TABLO KARŞILIĞI: " + esc(r.winnerRow.code) + " (" + esc(r.winnerRow.label) + ")";
      }
    } else {
      headline = esc(r.winnerRow.code);
      subline = esc(r.winnerRow.num) + " · " + esc(r.winnerRow.label) + " BEDEN";
    }
    var sizeCls = "fms-size" + (headline.length > 4 ? " fms-size--long" : "");

    var wrap = document.createElement("div");
    wrap.className = "fms-result";
    wrap.innerHTML =
      '<span class="fms-badge fms-reveal fms-reveal-1 ' + conf.cls + '">' + conf.label + "</span>" +
      '<div class="' + sizeCls + ' fms-reveal fms-reveal-2">' + headline + "</div>" +
      '<div class="fms-range-label fms-reveal fms-reveal-2">' + subline + "</div>" +
      '<p class="fms-copy fms-reveal fms-reveal-3">' + conf.copy + "</p>" +
      '<p class="fms-note fms-reveal fms-reveal-3">Beden uymazsa 14 gün içinde kolayca iade edebilirsin.</p>' +
      (availNote ? '<p class="fms-avail-note fms-reveal fms-reveal-3">' + availNote + "</p>" : "") +
      '<div class="fms-breakdown fms-reveal fms-reveal-4">' +
      breakdownCol("GÖĞÜS", state.bust, esc(r.picks.bust.row.code)) +
      breakdownCol("BEL", state.waist, esc(r.picks.waist.row.code)) +
      breakdownCol("BASEN", state.hip, esc(r.picks.hip.row.code)) +
      "</div>" +
      '<button type="button" class="fms-restart fms-reveal fms-reveal-4" data-fms-restart>Ölçüleri baştan gir</button>';
    var sheet = overlay.querySelector(".fms-sheet");
    sheet.insertBefore(wrap, overlay.querySelector("[data-fms-controls]"));

    var controls = overlay.querySelector("[data-fms-controls]");
    var ctaLabel = variantValue
      ? esc(variantValue) + " ile devam et"
      : esc(r.winnerRow.code) + " — Tamam";
    controls.innerHTML =
      '<div class="fms-buttons"><button type="button" class="fms-btn-next" data-fms-continue>' + ctaLabel + "</button></div>";
    controls.querySelector("[data-fms-continue]").addEventListener("click", function () {
      applyVariantSelection(r.winnerRow);
      closeQuiz();
    });
    wrap.querySelector("[data-fms-restart]").addEventListener("click", function () {
      resetState();
      renderStep();
    });
  }

  function openQuiz() {
    if (!config) {
      var cfgEl = document.querySelector("[data-fms-config]");
      if (!cfgEl) return;
      try { config = JSON.parse(cfgEl.textContent); } catch (err) { return; }
    }
    if (!overlay) buildOverlay();
    if (!started || completed) { resetState(); started = true; }
    overlay.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    renderStep();
  }

  function closeQuiz() {
    if (!overlay) return;
    overlay.classList.remove("is-open");
    document.documentElement.style.overflow = "";
  }

  /* Tetikleyici: tema section'ları yeniden yüklense bile çalışsın diye delegasyon */
  document.addEventListener("click", function (e) {
    var trigger = e.target.closest ? e.target.closest("[data-fms-open]") : null;
    if (trigger) {
      e.preventDefault();
      openQuiz();
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && overlay && overlay.classList.contains("is-open")) closeQuiz();
  });
})();